import {connect} from 'react-redux';
import LoaderComponent from '../../common/components/loader/LoaderComponent';

const mapStateToProps = state => ({
    loader: state.ui.loader
});

const mapDispatchToProps = dispatch => ({

});

const mergeProps = (stateProps, dispatchProps) => ({
    ...stateProps,
    ...dispatchProps
});

const LoaderContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(LoaderComponent);

export default LoaderContainer;
